import React, { useContext, useEffect, useState } from "react";
import {
  queryCarbonCoefficientById,
  queryCarbonCoefficientDetail,
  queryCarbonCoefficientIndex,
} from "../../../utility/service/carbonFootprint-service";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { checkDpSuccess } from "../../../utility/service/tool-service";
import { Card } from "primereact/card";
import { FormInput } from "../../../components/FormInput";
import { useTranslation } from "react-i18next";
import { Button } from "primereact/button";

import { RadioButton } from "primereact/radiobutton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CoefficientTable from "./CoefficientTable";
import { FormInputSearch } from "../../../components/FormInputSearch";
import PrimeDialog from "../../../components/dialog/PrimeDialog";
import CoefficientInfo from "./CoefficientInfo";
import { SystemLoading, checkLoading } from "../../../store/loadingStore";

// 產品碳係數
const CarbonCoefficientComponent = ({ pickData, register, errors, setPickDialog, getValues, applyFlag = true }) => {
  const [expandedRows, setExpandedRows] = useState(null);
  const [expandedRows2, setExpandedRows2] = useState(null);
  const [radio, setRadio] = useState(null);

  const [rows, setRows] = useState([]);
  const { t } = useTranslation();
  const [searchPage, setSearchPage] = useState(false);
  const [breadcrumbs, setBreadcrumbs] = useState("");
  const [tableData, setTableData] = useState([]);
  const [coefficientId, setCoefficientId] = useState("");
  const [materialTypeValue, setMaterialTypeValue] = useState("");
  const [detailDialog, setDetailDialog] = useState(false);
  const [detailRow, setDetailRow] = useState("");
  const [coefficientObj, setCoefficientObj] = useState({});
  const [, loading] = useContext(SystemLoading);
  const [isComposing, setIsComposing] = useState(false);
  const handleCompositionStart = () => setIsComposing(true);
  const handleCompositionEnd = () => setIsComposing(false);

  useEffect(() => {
    axios_queryCarbonCoefficientIndex();
  }, []);

  const axios_queryCarbonCoefficientIndex = () => {
    checkLoading(loading);
    queryCarbonCoefficientIndex()
      .then((res) => {
        if (checkDpSuccess(res)) {
          setRows(res?.data?.RespBody);
        }
      })
      .finally((fin) => {
        checkLoading(loading, false);
      });
  };

  const axios_queryCarbonCoefficientDetail = (reqBody, isMore = false) => {
    checkLoading(loading);
    queryCarbonCoefficientDetail(reqBody)
      .then((res) => {
        if (checkDpSuccess(res)) {
          let data = res?.data?.RespBody;
          if (data?.length > 0) {
            setCoefficientId(data[data?.length - 1].coefficientId);
            if (isMore === true) {
              setTableData((pre) => {
                return [...pre, ...data];
              });
            } else {
              setTableData(data);
            }
          } else {
            if (isMore === false) {
              setTableData([]);
            }
          }
        }
      })
      .finally((fin) => {
        checkLoading(loading, false);
      });
  };

  const callLevel4 = (item, rowData, currentRow) => {
    axios_queryCarbonCoefficientDetail({ materialTypeValue: item?.subitemNo });
    setMaterialTypeValue(item?.subitemNo);
    setSearchPage(true);
    let breadcrumbs = `${rowData?.subitemName}/${currentRow?.subitemName}/${item?.subitemName}`;
    setBreadcrumbs(breadcrumbs);
  };

  const handleBringIn = (data) => {
    setSearchPage(false);
    setPickDialog(false);
    pickData(data); //把值帶回畫面中
  };

  const btnReadMore = () => {
    let reqBody = {
      materialTypeValue: materialTypeValue,
      coefficientId: coefficientId,
    };
    if (materialTypeValue === "") {
      //這個是空的表示他是關鍵字搜尋
      reqBody.keywordSearch = getValues("keywordSearch");
    }
    axios_queryCarbonCoefficientDetail(reqBody, true);
  };

  const searchCoefficientId = (rowData) => {
    setDetailRow(rowData);
    checkLoading(loading);
    queryCarbonCoefficientById({
      coefficientId: rowData?.coefficientId,
    })
      .then((res) => {
        if (checkDpSuccess(res)) {
          let data = res?.data?.RespBody;
          setCoefficientObj(data);
          setDetailDialog(true);
        }
      })
      .finally((fin) => {
        checkLoading(loading, false);
      });
  };

  const handleKeywordSearch = () => {
    // 每次查詢前清空之前查詢的資料
    setMaterialTypeValue("");
    setCoefficientId("");

    axios_queryCarbonCoefficientDetail({ keywordSearch: getValues("keywordSearch") });
    setSearchPage(true);
    setBreadcrumbs(getValues("keywordSearch"));
  };

  // const subitemNameTemplate = (rowData) => {
  //     if (rowData) {
  //         return (<>{rowData?.subitemName} ({rowData?.dpItemsRecordsList?.length})</>)
  //     }
  // }
  // const rowExpansionTemplate = (data) => {
  //     return (
  //         <div className="ml-3">
  //             <DataTable
  //                 showHeaders={false}
  //                 value={data.dpItemsRecordsList}
  //                 expandedRows={expandedRows2}
  //                 onRowToggle={(e) => setExpandedRows2(e.data)}
  //                 rowExpansionTemplate={rowExpansionTemplate2}
  //             >
  //                 <Column expander style={{ width: '3em' }} />
  //                 <Column body={subitemNameTemplate} showHeaders={false} field="subitemName" header="名稱" />
  //             </DataTable>
  //         </div>
  //     );
  // };

  // const rowExpansionTemplate2 = (data) => {
  //     if (data?.dpItemsRecordsList?.length > 0) {
  //         return (
  //             <div className="grid d-flex flex-wrap ml-4">
  //                 {
  //                     data?.dpItemsRecordsList?.map((item, index) => (
  //                         <Card style={{ cursor: 'pointer' }} onClick={() => { pickData(item.subitemName) }} className="m-1" key={index} title={item.subitemName}>
  //                         </Card>
  //                     ))
  //                 }
  //             </div>
  //         );
  //     }

  // };

  const coefficientPanelLv3 = (level, items, rowData, currentRow) => {
    const levelColor = "#0D7FA8";

    if (level === 2) {
      return (
        <div className="grid">
          {items.map((item, index) => (
            <div
              onClick={() => {
                callLevel4(item, rowData, currentRow);
              }}
              key={index}
              className="col-10 lg:col-3 border-1 my-1"
              style={{ color: levelColor, marginLeft: "30px", cursor: "pointer" }}
            >
              <strong>{item.subitemName}</strong>
            </div>
          ))}
        </div>
      );
    }
  };

  const coefficientPanel = (items, level = 1, parentData = null) => {
    // 定義每層前方顏色
    const colors = ["#934545", "#FBBC63", "#0D7FA8"];
    // 計算當前層數的顏色，並處理層數超過顏色陣列的情況
    const levelColor = colors[(level - 1) % colors.length];
    // Item組件，處理每個項目的展開/收合
    return items.map((item, index) => (
      <Item
        key={index}
        item={item}
        level={level}
        levelColor={levelColor}
        parentData={parentData || item} // 傳遞當前層級的資料到下一層
      />
    ));
  };
  const Item = ({ item, level, levelColor, parentData }) => {
    // 使用useState來管理每個項目的展開/收合狀態
    const [isOpen, setIsOpen] = useState(false);

    // 處理展開/收合的邏輯
    const toggleOpen = () => {
      setIsOpen(!isOpen);
    };
    return (
      <>
        <div className="level-line" style={{ "--level-color": levelColor }}>
          <div className="panel-group">
            <span className="level-num"> {level}</span> {/* 顯示層數 */}
            <div className="panel">
              {/* 展開/收合按鈕 */}
              <Button
                type="button"
                severity="secondary"
                onClick={toggleOpen}
                rounded
                text
                icon={isOpen ? "pi pi-angle-down" : "pi pi-angle-right"}
              ></Button>
              <strong>{item.subitemName}</strong>
              <span>({item.dpItemsRecordsList.length})</span>
              {/* {level===3 && coefficientTable()} */}
            </div>
          </div>
          {isOpen && item.dpItemsRecordsList && item.dpItemsRecordsList.length > 0 && (
            <div style={{ marginLeft: "30px" }}>
              {/* 遞迴並增加層級 */}
              {/* 傳遞父層資料 */}
              {level < 2 && coefficientPanel(item.dpItemsRecordsList, level + 1, parentData)}
              {/* 傳遞父層資料 */}
              {coefficientPanelLv3(level, item.dpItemsRecordsList, parentData, item)}
            </div>
          )}
        </div>
      </>
    );
  };
  // const coefficientTable =()=>{
  //     return(<>
  //         {/* <div className='coefficient-table' >123</div> */}
  //         <table className='coefficient-table'>
  //             <thead>
  //                 <tr>
  //                     <td>選擇</td>
  //                     <td>碳係數名稱</td>
  //                     <td>數值</td>
  //                     <td>單位</td>
  //                     <td>宣告單位</td>
  //                     <td>公告年份</td>
  //                 </tr>
  //             </thead>
  //             <tbody>
  //                 <tr>
  //                     <td><RadioButton inputId="ingredient1" name="aaaa01" value="01" onChange={(e) => setRadio(e.value)} checked={radio === '01'} /></td>
  //                     <td>電力碳足跡(2021)</td>
  //                     <td>臺灣</td>
  //                     <td>6.06E-1 kgCO₂e</td>
  //                     <td>度(kwh)</td>
  //                     <td>2023</td>
  //                 </tr>
  //                 <tr>
  //                     <td><RadioButton inputId="ingredient2" name="aaaa01" value="02" onChange={(e) => setRadio(e.value)} checked={radio === '02'} /></td>
  //                     <td>電力間接碳足跡(2021)</td>
  //                     <td>臺灣</td>
  //                     <td>9.73E-2 kgCO₂e</td>
  //                     <td>度(kwh)</td>
  //                     <td>2023</td>
  //                 </tr>
  //             </tbody>
  //         </table>
  //     </>
  //     )
  // }
  return (
    <>
      <div className="col-12 lg:col-12">
        {/* 查詢關鍵字時 直接開啟第四層頁面 */}
        <FormInputSearch
          register={register}
          errors={errors}
          id="keywordSearch"
          type="text"
          placeholder={``}
          labelClass="control-label"
          labelText={t("keyword")}
          btnSerch={handleKeywordSearch}
          onCompositionStart={(e) => {
            handleCompositionStart();
          }}
          onCompositionEnd={(e) => {
            handleCompositionEnd();
          }}
          enterClick={(e) => {
            if (e.code === "Enter" && !isComposing) {
              handleKeywordSearch();
            }
          }}
        />
      </div>
      <div className="panel-tree-wrapper">
        {searchPage ? (
          <>
            <div className="flex justify-content-between flex-wrap align-items-center">
              <div className="align-items-start">
                <Button
                  rounded
                  text
                  onClick={() => {
                    setSearchPage(false);
                  }}
                >
                  <FontAwesomeIcon icon="fa-solid fa-arrow-left-long" />
                  {t("button.return_to_list")}
                </Button>
              </div>
              <label>
                {t("classify")}: {breadcrumbs}
              </label>
            </div>
            <CoefficientTable
              rows={tableData}
              bringIn={handleBringIn}
              btnReadMore={btnReadMore}
              searchCoefficientId={searchCoefficientId}
              applyFlag={applyFlag}
            />
          </>
        ) : (
          <>{coefficientPanel(rows)}</>
        )}
      </div>

      <PrimeDialog
        isShowConfBtn={false}
        scrollByBody={true}
        visible={detailDialog}
        onClose={() => {
          setDetailDialog(false);
        }}
        confirmLabel=""
        onConfirm={() => {
          setDetailDialog(false);
        }}
        title={detailRow?.coefficientName}
        size="lg"
        bodyTemplate={
          <>
            <CoefficientInfo coefficientObj={coefficientObj} />
          </>
        }
      />
    </>
  );
};

export default CarbonCoefficientComponent;
